import { graphic } from 'echarts/core';

export const getColorSchema = (theme: string | null = 'primary') => {
  let colors: Array<string> = [];
  let gradients: Array<graphic.LinearGradient> = [];

  switch (theme) {
    case 'primary':
      colors = ['#091e6c', '#072eb5', '#0b75fd', '#8938e5', '#ff04d5', '#c4c4c4', '#99999b', '#6e6d71', '#535255'];
      gradients = [
        // default gradient for SubTextImage
        new graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#007aff',
          },
          {
            offset: 0.15,
            color: '#2767f8',
          },
          {
            offset: 0.5,
            color: '#8938e5',
          },
          {
            offset: 0.95,
            color: '#ff00cf',
          },
        ]),
        new graphic.LinearGradient(1, 1, 0, 1, [
          {
            offset: 0,
            color: '#007aff',
          },
          {
            offset: 0.15,
            color: '#2767f8',
          },
          {
            offset: 0.5,
            color: '#8938e5',
          },
          {
            offset: 0.95,
            color: '#ff00cf',
          },
        ]),
        new graphic.LinearGradient(1, 1, 1, 0, [
          {
            offset: 0,
            color: '#007aff',
          },
          {
            offset: 0.15,
            color: '#2767f8',
          },
          {
            offset: 0.5,
            color: '#8938e5',
          },
          {
            offset: 0.95,
            color: '#ff00cf',
          },
        ]),
        new graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: '#007aff',
          },
          {
            offset: 0.15,
            color: '#2767f8',
          },
          {
            offset: 0.5,
            color: '#8938e5',
          },
          {
            offset: 0.95,
            color: '#ff00cf',
          },
        ]),
      ];
      break;
    case 'secondary':
      colors = ['#003849', '#006A70', '#09A6A3', '#C3568C', '#F8374E', '#c4c4c4', '#99999b', '#6e6d71', '#535255'];
      gradients = [
        new graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: '#FC354C',
          },
          {
            offset: 0.5,
            color: '#B27CB8',
          },
          {
            offset: 1,
            color: '#0ABFBC',
          },
        ]),
        new graphic.LinearGradient(1, 1, 0, 1, [
          {
            offset: 0,
            color: '#FC354C',
          },
          {
            offset: 0.5,
            color: '#B27CB8',
          },
          {
            offset: 1,
            color: '#0ABFBC',
          },
        ]),
        new graphic.LinearGradient(1, 1, 1, 0, [
          {
            offset: 0,
            color: '#FC354C',
          },
          {
            offset: 0.5,
            color: '#B27CB8',
          },
          {
            offset: 1,
            color: '#0ABFBC',
          },
        ]),
        new graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: '#FC354C',
          },
          {
            offset: 0.5,
            color: '#B27CB8',
          },
          {
            offset: 1,
            color: '#0ABFBC',
          },
        ]),
      ];
      break;
    case 'tertiary':
      colors = ['#450039', '#73004C', '#BB1DB5', '#E42B14', '#FB7700', '#C4C4C4', '#99999B', '#6E6D71', '#535255'];
      gradients = [
        new graphic.LinearGradient(1, 0, 0, 0, [
          {
            offset: 0,
            color: '#BB1DB5',
          },
          {
            offset: 0.43,
            color: '#CE238A',
          },
          {
            offset: 0.71,
            color: '#E42B14',
          },
          {
            offset: 1,
            color: '#F09819',
          },
        ]),
        new graphic.LinearGradient(1, 1, 0, 1, [
          {
            offset: 0,
            color: '#F09819',
          },
          {
            offset: 0.43,
            color: '#E42B14',
          },
          {
            offset: 0.71,
            color: '#CE238A',
          },
          {
            offset: 1,
            color: '#BB1DB5',
          },
        ]),
        new graphic.LinearGradient(1, 1, 1, 0, [
          {
            offset: 0,
            color: '#F09819',
          },
          {
            offset: 0.43,
            color: '#E42B14',
          },
          {
            offset: 0.71,
            color: '#CE238A',
          },
          {
            offset: 1,
            color: '#BB1DB5',
          },
        ]),
        new graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: '#F09819',
          },
          {
            offset: 0.43,
            color: '#E42B14',
          },
          {
            offset: 0.71,
            color: '#CE238A',
          },
          {
            offset: 1,
            color: '#BB1DB5',
          },
        ]),
      ];
      break;
    case 'quaternary':
      colors = ['#280F59', '#59068C', '#9614E5', '#27B1CF', '#21E0DD', '#c4c4c4', '#99999b', '#6e6d71', '#535255'];
      gradients = [
        new graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: '#2DE0DD',
          },
          {
            offset: 0.39,
            color: '#27B1CF',
          },
          {
            offset: 1,
            color: '#A410FF',
          },
        ]),
        new graphic.LinearGradient(1, 1, 0, 1, [
          {
            offset: 0,
            color: '#2DE0DD',
          },
          {
            offset: 0.39,
            color: '#27B1CF',
          },
          {
            offset: 1,
            color: '#A410FF',
          },
        ]),
        new graphic.LinearGradient(1, 1, 1, 0, [
          {
            offset: 0,
            color: '#2DE0DD',
          },
          {
            offset: 0.39,
            color: '#27B1CF',
          },
          {
            offset: 1,
            color: '#A410FF',
          },
        ]),
        new graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: '#2DE0DD',
          },
          {
            offset: 0.39,
            color: '#27B1CF',
          },
          {
            offset: 1,
            color: '#A410FF',
          },
        ]),
        new graphic.LinearGradient(0, 0, 1, 0, [
          {
            offset: 0,
            color: '#2DE0DD',
          },
          {
            offset: 0.39,
            color: '#27B1CF',
          },
          {
            offset: 1,
            color: '#A410FF',
          },
        ]),
        new graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 0,
            color: '#A410FF',
          },
          {
            offset: 0.5,
            color: '#27B1CF',
          },
          {
            offset: 1,
            color: '#2DE0DD',
          },
        ]),
      ];
      break;
    default:
      break;
  }

  return { colors, gradients };
};
